<script setup lang="ts">
import { ref } from 'vue'
import QrcodeVue, { Level, RenderAs } from 'qrcode.vue'

const authStore = useAuthStore()
const { t } = useLocale()

const renderAs = ref<RenderAs>('svg')
const level = ref<Level>('H')

const userMetadata = computed(() => authStore.userMetadata)
const value = computed(
  () => `${userMetadata.value?.mcId}|${userMetadata.value?.firstname}|${userMetadata.value?.cpf}`
)
const contentQR = { tKey: 'onboarding.stepQR', action: true, isLast: true }
</script>

<template>
  <PopperWrapper data-popper="stepQR" placement="bottom">
    <div
      class="relative flex h-32 w-full flex-row justify-between rounded-md bg-mcd-main bg-[url('/images/QRCard/group2007.svg')] bg-contain bg-no-repeat shadow-xl md:w-96"
    >
      <div class="flex w-2/3 flex-col justify-end p-3">
        <div class="flex items-center gap-2">
          <h4 class="text-xl">
            {{ t('profile.tooltipProfile.greeting') }}
          </h4>
          <h4 class="line-clamp-1 text-xl font-bold">{{ userMetadata?.firstname }}</h4>
        </div>
        <div class="text-xs">McID: {{ userMetadata?.mcId }}</div>
      </div>
      <figure class="relative w-32">
        <img
          class="absolute bottom-0 right-0 h-full w-full rounded-md"
          src="/images/QRCard/Vector.svg"
          alt="qr background"
        />
        <qrcode-vue
          class="absolute left-1/2 top-1/2 h-full -translate-x-1/2 -translate-y-1/2 pl-2"
          :value="value"
          :level="level"
          :render-as="renderAs"
        />
      </figure>
    </div>
    <template #content="{ close }">
      <McdPopper :close="close" :content="contentQR" />
    </template>
  </PopperWrapper>
</template>
